import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18d86e12&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./treatmentPlan.scss?vue&type=style&index=0&id=18d86e12&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d86e12",
  null
  
)

export default component.exports